import { Component, DestroyRef, inject, Input, OnInit, signal } from '@angular/core';
import { FormControl, ReactiveFormsModule } from "@angular/forms";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import {
  CommonModalWrapperComponent
} from "@shared/components/commons/common-modal-wrapper/common-modal-wrapper.component";
import { DisclaimerComponent } from "@shared/components/commons/disclaimer/disclaimer.component";
import {
  DinMaskedInputComponent
} from "@shared/controls/masked-input/specific-masked-inputs/din-masked-input/din-masked-input.component";
import { IndividualsApiService } from "@shared/services/individuals-api.service";
import { ToastrService } from "ngx-toastr";

@Component({
  selector: 'app-edit-individual-din-modal',
  standalone: true,
  imports: [
    ReactiveFormsModule,
    DinMaskedInputComponent,
    CommonModalWrapperComponent,
    DisclaimerComponent
],
  templateUrl: 'edit-individual-din-modal.component.html',
})
export class EditIndividualDinModalComponent implements OnInit {
  individualApiService = inject(IndividualsApiService);
  activeModal = inject(NgbActiveModal);
  toastr = inject(ToastrService);
  destroyRef = inject(DestroyRef);

  message = 'Updating the Director ID will automatically update the officeholder page for all entities where the individual is a director or alternate director. Do you want to continue?';

  @Input() individualId!: string;
  @Input() din!: string;

  isLoading = signal<boolean>(false);
  dinControl = new FormControl<string | null>(null);

  ngOnInit(): void {
    if (!this.individualId) {
      this.close();
      throw new Error('No individual passed');
    }

    this.dinControl.setValue(this.din ?? null);
  }

  submit(): void {
    if (this.dinControl.invalid) {
      this.dinControl.markAsTouched();
      return;
    }

    this.isLoading.set(true);
    this.individualApiService.updateIndividualPart('din', this.individualId, this.dinControl.value)
      .subscribe({
        next: () => {
          this.toastr.success('Director ID updated successfully', 'Success');
          this.activeModal.close(this.dinControl.value);
        },
        error: (error) => {
          console.warn('[EditIndividualDinModalComponent.submit] error: ', error);
          this.toastr.error('Failed to update Director ID', 'Error');
          this.isLoading.set(false);
        }
      });
  }

  close(): void {
    this.activeModal.dismiss();
  }
}
